import {GridList} from 'shells/grid-list/grid-list';
import {StatCard} from 'shells/metrics/stat-card/stat-card';

import {useGetSchedulerStats} from './graphql/hooks/use-get-scheduler-stats';

interface Props {
    meetingId: string;
}

export function StatsSection(props: Props) {
    const {schedulerStats, isLoading} = useGetSchedulerStats({meetingId: props.meetingId});

    return (
        <GridList numColumns={4}>
            <StatCard
                displayName='Total views'
                value={schedulerStats?.totalViews?.toString()}
                type='text'
                isLoading={isLoading}
            />
            <StatCard
                displayName='Conversion rate'
                value={((schedulerStats?.conversionRate ?? 0) * 100).toString()}
                type='percent'
                tooltipInfo='The percentage of views that resulted in a booking'
                showProgressBars={false}
                isLoading={isLoading}
            />
            <StatCard
                displayName='Total bookings'
                value={schedulerStats?.totalBookings?.toString()}
                type='text'
                isLoading={isLoading}
            />
            <StatCard
                displayName='Average time until booking'
                value={schedulerStats?.averageTimeUntilBooking?.formatted?.toString() || 'N/A'}
                type='text'
                tooltipInfo='The average time between making the booking and the meeting start'
                isLoading={isLoading}
            />
        </GridList>
    );
}
